<template>
    <v-navigation-drawer v-model="drawer" clipped fixed app>
        <v-list dense expand>
            <template v-for="(navItem, navIndex) in nav">
                <template v-if="isRoleValid(navItem)">
                    <v-list-group v-if="navItem.children" v-bind:key="navIndex" :prepend-icon="navItem.icon" no-action
                        :value="containActiveNav(navItem)">
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-title>{{ navItem.text }}</v-list-tile-title>
                            </v-list-tile>
                        </template>
                        <v-list-tile v-for="(navSubItem, navSubIndex) in navItem.children" v-bind:key="navSubIndex"
                            @click="redirectToPath(navSubItem)" :class="comparePath(navSubItem.path)">
                            <template v-if="isRoleValid(navSubItem)">
                                <v-list-tile-action v-if="navSubItem.icon">
                                    <v-icon>{{ navSubItem.icon }}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-title>{{ navSubItem.text }}</v-list-tile-title>
                            </template>
                        </v-list-tile>
                    </v-list-group>
                    <v-list-tile v-if="!navItem.children" v-bind:key="navIndex"
                        @click="navItem.path ? redirectToPath(navItem) : goToLink(navItem)"
                        :class="comparePath(navItem.path)">
                        <v-list-tile-action>
                            <v-icon>{{ navItem.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-title>{{ navItem.text }}</v-list-tile-title>
                    </v-list-tile>
                </template>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>
<script>
import { mapState } from 'vuex'
import _ from 'lodash'

export default {
    name: 'Navigation',
    data() {
        return {}
    },
    computed: {
        drawer: {
            get() {
                return this.$store.state.navigation
            },
            set(val) {
                this.$store.dispatch(this.$actionTypes.NAVIGATION, val)
            }
        },
        nav() {
            let nav = [
                {
                    text: this.$t('agentAssessment'),
                    icon: 'icon-agent-analytic',
                    path: '/agent/',
                    children: [
                        {
                            text: this.$t('overview'),
                            icon: 'icon-overview',
                            path: '/agent/overview'
                        },
                        {
                            text: this.$t('details'),
                            icon: 'icon-detail',
                            path: '/agent/details'
                        }
                    ]
                },
                {
                    text: this.$t('botAssessment'),
                    icon: 'icon-bot-analysis',
                    path: '/bot/',
                    children: [
                        {
                            text: this.$t('overview'),
                            icon: 'icon-overview',
                            path: '/bot/overview'
                        },
                        {
                            text: this.$t('details'),
                            icon: 'icon-detail',
                            path: '/bot/details'
                        }
                    ]
                },
                // {
                //     text: this.$t('messageReaction'),
                //     icon: 'icon-meesage-satisfaction',
                //     path: '/satisfaction'
                // },
                {
                    text: this.$t('settings'),
                    icon: 'icon-setting',
                    path: '/settings'
                }
            ]
            for (let navItem of nav) {
                navItem.text = this.$filters.capitalizeAll(navItem.text)
                if (navItem.children) {
                    for (let navItemChild of navItem.children) {
                        navItemChild.text = this.$filters.capitalizeAll(navItemChild.text)
                    }
                }
            }
            return nav
        },
        ...mapState({
            activeProject: state => state.user.activeProject,
            projects: state => state.user.projects,
            userRoles: state => state.user.roles
        })
    },
    methods: {
        redirectToPath(navItem) {
            if (navItem.projectId) {
                if (!this.projectId) {
                    this.$appService.toastError(this.$t('noProjectSelectedError') + ' ' + navItem.text)
                    return
                }
            }
            let path = navItem.path
            this.$router.push(`/campaign/${this.activeProject.id}` + path)
        },
        goToLink(navItem) {
            window.location.href = navItem.link
        },
        comparePath(path) {
            return this.$route.path.includes(path) ? 'active_navigation' : ''
        },
        containActiveNav(navItem) {
            for (let item of navItem.children) {
                if (this.comparePath((item.path))) {
                    return true
                }
            }
            return false
        },
        isRoleValid(navItem) {
            if (navItem.roles) {
                let roles = Array.isArray(navItem.roles) ? navItem.roles : [navItem.roles]
                return _.difference(roles, this.userRoles).length < roles.length
            }
            return true
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep .active_navigation {
    background: #f5ecec;
}

::v-deep .active_navigation .v-list__tile__title {
    color: #3BC1D4;
    /*font-weight: bold;*/
    transition: all linear 0s;
}

::v-deep .v-list__tile__title {
    color: #8D94AD;
    font-size: 14px;
    font-weight: normal;
}

::v-deep i {
    color: #8D94AD !important;
    caret-color: #8D94AD !important;

    &:before {
        color: #8D94AD !important;
    }
}
</style>
